<div class="container-fluid padMob webView " style="padding-left: 25px; padding-right: 15px;">

    <div class="row ">
        <div class="col-md-12 col-12 col-sm-12 ">
            <div class="col-md-4 col-sm-12 col-12 inlnBlk pad0">
                <h2 style="margin-top: 17px;" class="lblHeader newHeader"> Bank Reconciliation</h2>
            </div>
            <div class="col-md-8 col-sm-12 col-12 inlnBlk pad0 txtAlignRgt">
                <span class="orangeBadgeCnt font13 brdrRadius3" style="border: 1px solid;  color: #e88421; padding: 6px 10px;
                background-color: white;" *ngIf="tempdata.length!=0">
                    ₹ {{bankBalance | cRDB}}
                </span>

                <span class="search">
                    <span class="fa fa-search" style="position: relative !important;left: 24px !important;top: 0px !important;"></span>
                    <input class="form-control formCtlFltr brdrRadius3" ng-model="search.term" placeholder="Search" matInput
                        (keyup)="applyFilter($event)" #input
                        style="text-align: left; margin-right: 10px; display: inline-block; padding-left: 35px !important; font-size: 13px; box-shadow: none; width: 20% !important; height: 31px !important;"
                        type="text">
                </span>
                <!-- <div class="col-sm-12 col-xs-12 webView" style="padding: 0px; float: right; width: 32%;">
                    <span class="fa fa-search" style="position:relative; left: 14px; top: 8px;"></span>
                    <input class="form-control foc  BzBgwhite"  placeholder="Search"
                            style="border-color: #E4E4E4; border-radius: 25px !important; box-shadow: none; margin-top: -20px;
                                        text-indent: 30px;" type="text">
                </div> -->

                <!-- <span (click)="refresh()" class="btn btn-brown"
                    style="cursor: pointer;line-height: 22px; padding: 5px 11px; color:#fff; border-radius: 25px;margin-left: 10px;"
                    title="Refresh">
                    <span>
                        <i aria-hidden="true" style="font-size: 16px;" class="fa fa-refresh"></i>
                    </span>
                </span> -->

                <span *ngIf="(tempdata.length > 0) && (isAdmin == true)" class="btn btn-orange fntSz brdrRadius3"  (click)="exportToExcelActivities()" title="Export to Excel"
                    style="cursor:pointer;margin-right: 10px;line-height: 22px;padding: 2px 7px;">
                    <span>
                        <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                    </span>
                </span>

                <span (click)="refresh()"  class="btn btn-orange brdrRadius3"
                    style="cursor: pointer;line-height: 22px; padding: 2px 7px; margin-right: 10px" title="Refresh">
                    <span>
                        <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
                    </span>
                </span>

                <span *ngIf="tempdata.length > 0" (click)="PrintReconciliation()" style="margin-right: 10px;" >
                    <span title="Print" class="btn btn-orange brdrRadius3"
                        style="line-height: 22px !important; font-size: 13px !important; color:#fff;padding: 2px 7px">
                        <span>
                            <i aria-hidden="true" class="zmdi zmdi-print"
                                style="font-size: 14px; position: relative; top: 1px;"></i>
                        </span>
                    </span>
                </span>

                <div style="display: inline-block; text-align: right; padding: 0px;">
                    <span class="btn-darkBlue brdrRadius3" style="font-size: 13px; display: inline-block; padding: 2px 7px;"
                        (click)="backBtn()">
                        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back
                    </span>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-12 col-sm-12 ">
            <div class="col-md-8 col-sm-12 col-12 inlnBlk pad0" style="margin-top: 10px; margin-bottom: 15px;">

                <!-- <span class="inlnBlk">
                    Ledger :
                </span> -->
                <span class="" style="display: inline-grid">
                    <input type="text" matInput list="bankLedgerList" class="form-control formCtlFltr font13 bgwhite" tabindex="1"
                        placeholder="Select a bank ledger" title="Select a bank ledger" (blur)="changeLedger();"
                        style="display: inline-block;
                        padding: 1px 3px;
                        font-size: 12px !important;
                        cursor: pointer;" [(ngModel)]="bankName">
                    <datalist id="bankLedgerList">
                        <option *ngFor="let a of bankList" [value]="a.LNm">{{a.LNm}}</option>
                    </datalist>
                    <!-- <span  *ngIf="bankList.length == 1" *ngIf="bankList.length > 0" class="inlnBlk" style="margin-left: 10px;">
                        <input type="text" list="bankLedgerList" id="txtItem" class="form-control " tabindex="1"
                            placeholder="Select a bank ledger" title="Category" (blur)="changeLedger();"
                            style=" width: 97%; background: inherit; height: 30px; cursor: pointer;"
                            [(ngModel)]="bankName">

                        <datalist id="bankLedgerList">
                            <option *ngFor="let a of bankList" [value]="a.BNm">{{a.BNm}}</option>
                        </datalist>
                    </span> -->
                </span>

                <span class="date inlnBlk" style="margin-left:30px;line-height: 30px;">
                    <span
                        style="font-size: 14px !important;">
                        <input matInput [matDatepicker]="picker" [(ngModel)]="startDate" (focus)="picker.open()"
                            class="customFocus form-control formCtlFltr bgwhite " (ngModelChange)="fn_ChangeDate()" readonly
                            style="color:#555 !important; display: inline-block; width: 80px; background: #FFF; cursor: pointer; font-size: 13px;text-indent: 5px;vertical-align: middle;">
                        <mat-datepicker-toggle matSuffix [for]="picker" style="vertical-align: middle;"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </span>

                    <span style="font-size: 13px;">to</span>
                    <span
                        style="margin-right: 25px;margin-left: 15px;font-size: 14px !important;">
                        <input [min]="startDate" matInput [matDatepicker]="Newdate" [(ngModel)]="endDate" (focus)="Newdate.open()"
                            class="customFocus form-control formCtlFltr bgwhite " (ngModelChange)="fn_ChangeDate()" readonly
                            style="color:#555 !important;display: inline-block; width: 80px; background: #FFF; cursor: pointer;font-size: 13px;text-indent: 5px;vertical-align: middle;">
                        <mat-datepicker-toggle matSuffix [for]="Newdate" style="vertical-align: middle;"></mat-datepicker-toggle>
                        <mat-datepicker #Newdate></mat-datepicker>
                    </span>
                </span>
            </div>
        </div>

        <div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px;" *ngIf="tempdata.length > 0">
            <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow">
                <table mat-table [dataSource]="dataSource" matSort style="width: 100%;font-family: sans-serif !important; border-radius: 3px;">

                    <!-- ID Column -->
                    <ng-container matColumnDef="EffectiveDate">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                            <label style="cursor: pointer;"> Voucher Date</label>
                        </th>
                        <td mat-cell *matCellDef="let row"> {{row.EffectiveDate | todayTommorow}} </td>
                    </ng-container>
    
                    <!-- Progress Column -->
                    <ng-container matColumnDef="VoucherNum">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                            <label style="cursor: pointer;"> Voucher No.</label>
                        </th>
                        <td style="color: #e88421;cursor: pointer;" mat-cell *matCellDef="let row"
                            (click)="openEditVoucher(row.VoucherID)"> {{row.VoucherNum == '' ? '-' : row.VoucherNum
                            }} </td>
                    </ng-container>
    
                    <!-- Name Column -->
                    <ng-container matColumnDef="PaymentMode">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header><label> Payment
                                Mode</label> </th>
                        <td mat-cell *matCellDef="let row">
                            <span *ngIf="!row.IsEdit"> {{row.PaymentMode == '0' ? '-' : row.PaymentMode }} </span>
                            <span *ngIf="row.IsEdit">
                                <select class="form-control" style="width: 90%; cursor: pointer;"
                                    [(ngModel)]="row.tmpPaymentMode">
                                    <option value="">--Select--</option>
                                    <option value="Cash">Cash</option>
                                    <option value="Cheque">Cheque</option>
                                    <option value="Credit Card">Credit Card</option>
                                    <option value="Demand Draft">Demand Draft</option>
                                    <option value="Intra-Bank">Intra-Bank</option>
                                    <option value="IMPS">IMPS</option>
                                    <option value="NEFT">NEFT</option>
                                    <option value="RTGS">RTGS</option>
                                    <option value="UPI">UPI</option>
                                </select>
    
                            </span>
                        </td>
                    </ng-container>
    
                    <!-- Color Column -->
                    <ng-container matColumnDef="PaymentRef">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="cursor: pointer;"> <label style="cursor: pointer;"> Payment
                                Ref. </label> </th>
                        <td mat-cell *matCellDef="let row" style="width: 10%;">
                            <span style="display: inline-flex; margin-right: 10px;" *ngIf="!row.IsEdit"> {{ row.PaymentRef
                                == '' ? '-' : row.PaymentRef }}</span>
                            <span style="display: inline-flex;" *ngIf="row.IsEdit">
                                <input type="text" class="form-control" [(ngModel)]="row.tmpPaymentRef"
                                    style="width: 80%;"></span>
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="MainLedger">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="cursor: pointer;"> <label style="cursor: pointer;"> Ledger
                            </label></th>
                        <td mat-cell *matCellDef="let row"> {{row.MainLedger}} </td>
                    </ng-container>
    
                    <ng-container matColumnDef="CrAmt">
                        <th class="header header-Table align-left-pd" arrowPosition='before'  mat-header-cell *matHeaderCellDef mat-sort-header style="cursor: pointer;">
                            <label style="cursor: pointer;"> Credit</label>
                        </th>
                        <td mat-cell *matCellDef="let row" class="txtAlignRgt"> {{row.CrAmt | lacFormat}} </td>
                    </ng-container>
    
                    <ng-container matColumnDef="DbAmt" style="padding-right: 5px;">
                        <th class="header header-Table align-left-pd" arrowPosition='before' mat-header-cell *matHeaderCellDef mat-sort-header style="cursor: pointer;"><label style="cursor: pointer;"> Debit </label></th>
                        <td mat-cell *matCellDef="let row" class="txtAlignRgt"> {{row.DbAmt |
                            lacFormat}}
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="CloBal">
                        <th class="header header-Table align-left-pd" arrowPosition='before' mat-header-cell *matHeaderCellDef mat-sort-header style="cursor: pointer;"> <label style="cursor: pointer;"> Balance
                            </label> </th>
                        <td mat-cell *matCellDef="let row" class="txtAlignRgt"> {{row.CloBal == 0 ? '-' : row.CloBal |
                            cRDB}} </td>
                    </ng-container>
    
                    <ng-container matColumnDef="ReconDate">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left:15px;cursor: pointer;"> <label> Recon.
                                Date </label></th>
                        <td mat-cell *matCellDef="let row" style="padding-left:15px">
                            <span *ngIf="!row.IsEdit">{{row.ReconDate}}</span>
                            <span *ngIf="row.IsEdit">
                                <input [max]="maxDate" matInput [matDatepicker]="pickernew" [(ngModel)]="row.tmpReconDate"
                                    (focus)="pickernew.open()" class="form-control" tabindex="1"
                                    style="display: inline-block; width: 70px;background: #fff; cursor: pointer;">
                                <mat-datepicker-toggle matSuffix [for]="pickernew" style="display: none;">
                                </mat-datepicker-toggle>
                                <mat-datepicker #pickernew></mat-datepicker>
                            </span>

                            <div class="lableBtnGray inLneBlk" *ngIf="row.IsEdit && row.tmpReconDate" (click)="removeRecon(row)"
                                style="border-radius: 50%; margin-left: 10px;font-size: 14px; padding: 2px 8px 1px; cursor: pointer; vertical-align: super;">
                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                            </div>
                            
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="Actions">
                        <th mat-header-cell *matHeaderCellDef style="border-radius: 10px;"> </th>
                        <td mat-cell *matCellDef="let row" style="width: 80px; padding: 0px; padding-left: 10px;">
                            <div class="lableBtnOrange inLneBlk brdrRadius3" style="border-radius: 3px; cursor: pointer; padding: 3px 8px !important;"
                                (click)="editReconsi(row)" *ngIf="!row.IsEdit">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </div>
                            <div class="lableBtnOrange inLneBlk brdrRadius3"
                                style="border-radius: 3px; padding: 3px 7px !important; cursor: pointer;" (click)="Save(row)"
                                *ngIf="row.IsEdit">
                                <i class="fa fa-check" aria-hidden="true"></i>
                            </div>
                            <div class="lableBtnDrkBlue inLneBlk brdrRadius3" *ngIf="!row.IsEdit"
                                style="border-radius: 3px;margin-left: 10px;font-size: 13px; cursor: pointer; padding: 2px 9px !important;"
                                (click)="openNewWindowVoucher('$event')">
                                <i class="zmdi zmdi-plus" aria-hidden="true"></i>
                            </div>
                            <div class="lableBtnDrkBlue  inLneBlk brdrRadius3" *ngIf="row.IsEdit" (click)="editClose()"
                                style="border-radius: 3px; margin-left: 10px;font-size: 13px; padding: 3px 7px !important; cursor: pointer;">
                                <i class="zmdi zmdi-close" aria-hidden="true"></i>
                            </div>
                        </td>
                    </ng-container>
    
    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    
                    <!-- Row shown when there is no matching data. -->
                    <!-- <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                    </tr> -->
    
    
                </table>
                <mat-paginator [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
            </div>
        </div>
        <div class="col-md-12" *ngIf="tempdata.length == 0">
            <div class="nrf">
                No voucher found.
            </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12" style="margin-top:10px;">
            <span class="greenBadge" style="font-size:13px; display: none;" *ngIf="tempdata.length!=0">
                ₹ {{ bankBalance | cRDB}}
            </span>
        </div>
    </div>
</div>

<!-- 
<ng-template #mymodal let-modal style="font-family: sans-serif !important; margin: auto;">
  
    <div class="modal-body" style="font-size: 14px !important; padding: 0px; !important; position: relative;
            right: 137px;">
        <app-voucher-entry (oncloseVchrModal)="closeModal($event)"></app-voucher-entry>
    </div>
</ng-template> -->

<!--Voucher Entry Modal-->
<ng-template #mymodal let-modal>
    <div class="modal-body" style="padding: 0px;">
      <app-voucher-entry (oncloseVchrModal)="closeModal($event)"></app-voucher-entry>
    </div>
</ng-template>
<!--loding panel-->
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>
